export const navItems = {
    my: [
        { title: 'ပင်မ', path: '/' },
        {
            title: 'စာသင်သားသံဃာသစ်များ',
            submenu: [
                { title: 'လက်ခံပုံ', path: '/new-monks/accepting-rules' },
                { title: 'ယူလာရမည့်ပစ္စည်း', path: '/new-monks/requirements' },
                { title: 'လက်ခံချိန်နှင့် သံဃာထိန်းသိမ်းရေး', path: '/new-monks/acceptance-season' }
            ]
        },
        {
            title: 'အုပ်ချုပ်ရေး',
            submenu: [
                { title: 'အာမခံဆရာ', path: '/administration/guardians' },
                { title: 'ဒဏ်တောင်းခြင်း', path: '/administration/punishments' },
                { title: 'ဘာသာစကား', path: '/administration/languages' }
            ]
        },
        {
            title: 'ပညာရေး',
            submenu: [
                { title: 'အခြေခံပညာရေး', path: '/education/basic' },
                { title: 'ပိဋကတ် အခြေပြုပညာရေး', path: '/education/pidakat-base' },
                { title: 'ပိဋကတ်ပညာရေး', path: '/education/pidakat' }
            ]
        },
        {
            title: 'ကျောင်းတိုက်အကြောင်း',
            submenu: [
                { title: 'Mahãvihãra and Pali', path: '/about/pali' },
                { title: 'Mahãvihãra and Tharmanay Kyaw', path: '/about/tharmanay-kyaw' },
                { title: 'Mahãvihãra and Sar Wah', path: '/about/sar-wah' },
                { title: 'Mahãvihãra and Foreign Monks', path: '/about/foreign-monks' },
                { title: 'Mahãvihãra and အာပတ်ကို ကုစားခြင်း', path: '/about/apad' },
                { title: 'Mahãvihãra and ရဟန်းလောင်းများ', path: '/about/future-monks' },
                { title: 'Mahãvihãra and Meditation', path: '/about/meditation' }
            ]
        },
        { title: 'လှုပ်ရှားမှု', path: '/activities' },
        { title: 'မှတ်တမ်း', path: '/gallery' }
    ],
    en: [
        { title: 'Home', path: '/' },
        {
            title: 'Novice Monks',
            submenu: [
                { title: 'Accepting Rules', path: '/new-monks/accepting-rules' },
                { title: 'Requirements', path: '/new-monks/requirements' },
                { title: 'Acceptance Season & Regulations', path: '/new-monks/acceptance-season' }
            ]
        },
        {
            title: 'Guardians',
            submenu: [
                { title: 'Guardians', path: '/administration/guardians' },
                { title: 'Punishments', path: '/administration/punishments' },
                { title: 'Languages', path: '/administration/languages' }
            ]
        },
        {
            title: 'Education',
            submenu: [
                { title: 'Basic Education', path: '/education/basic' },
                { title: 'Pi Da Kat Base Education', path: '/education/pidakat-base' },
                { title: 'Pi Da Kat Education', path: '/education/pidakat' }
            ]
        },
        {
            title: 'About',
            submenu: [
                { title: 'Mahãvihãra and Pali', path: '/about/pali' },
                { title: 'Mahãvihãra and Tharmanay Kyaw', path: '/about/tharmanay-kyaw' },
                { title: 'Mahãvihãra and Sar Wah', path: '/about/sar-wah' },
                { title: 'Mahãvihãra and Foreign Monks', path: '/about/foreign-monks' },
                { title: 'Mahãvihãra and အာပတ်ကို ကုစားခြင်း', path: '/about/apad' },
                { title: 'Mahãvihãra and ရဟန်းလောင်းများ', path: '/about/future-monks' },
                { title: 'Mahãvihãra and Meditation', path: '/about/meditation' }
            ]
        },
        { title: 'Activities', path: '/activities' },
        { title: 'Gallery', path: '/gallery' }
    ]
};